import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export function useLockBodyScroll(lock) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== lock) {
    t0 = () => {
      if (lock) {
        const scrollY = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
        return () => {
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.width = "";
          window.scrollTo(0, scrollY);
        };
      }
    };
    t1 = [lock];
    $[0] = lock;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}